import { useState } from 'react';
import { Button, Typography } from '@uigovpe/components';
import { Profile } from '@/shared/types/certificate-request';
import { ContactVerificationForm } from '@/shared/components/ContactVerificationForm';
import { ContactInput } from '../../api/profileApi';

interface ContactStepProps {
  profile: Profile;
  busy: boolean;
  error?: string | null;
  codeRecipient?: string | null;
  onSaveContact: (input: ContactInput) => Promise<void>;
  onSendCode: () => Promise<boolean>;
  onVerifyCode: (code: string) => Promise<void>;
  onBack: () => void;
  onNext: () => void;
}

/**
 * Etapa 3. Só aparece quando o e-mail ainda não foi confirmado (primeira
 * solicitação, ou quando o cidadão trocou o e-mail na tela de Perfil).
 * Perfil já com e-mail confirmado pula direto para a Revisão — ver
 * `leaveIncidentStep` em `useRequestWizard.ts`.
 */
export function ContactStep({
  profile,
  busy,
  error,
  codeRecipient,
  onSaveContact,
  onSendCode,
  onVerifyCode,
  onBack,
  onNext,
}: ContactStepProps) {
  const [confirmed, setConfirmed] = useState(profile.emailConfirmed);

  return (
    <div className="cd-step-page">
      <section className="cd-step">
        <Typography variant="h2" size="lg" fontWeight="bold">
          Como falamos com você
        </Typography>
        <Typography variant="p" size="sm" className="cd-step__hint">
          O protocolo e as atualizações vão para este e-mail. A equipe do Corpo de
          Bombeiros também pode ligar para concluir a emissão.
        </Typography>

        <ContactVerificationForm
          profile={profile}
          busy={busy}
          error={error}
          codeRecipient={codeRecipient}
          onSaveContact={onSaveContact}
          onSendCode={onSendCode}
          onVerifyCode={onVerifyCode}
          onConfirmedChange={setConfirmed}
        />
      </section>

      <div className="cd-actions cd-actions--outside">
        <Button label="Voltar" outlined icon="pi pi-arrow-left" onClick={onBack} />
        <Button
          label="Revisar"
          icon="pi pi-arrow-right"
          iconPos="right"
          disabled={!confirmed}
          onClick={onNext}
        />
      </div>
    </div>
  );
}
